/* Fair Shoe Care product page: gallery (foto's + video, swipe), quantity + total, optional add-on, add to cart,
   video in het groene vlak en een sticky koopbalk. Gebruikt een pp- prefixed cart:update event voor de winkelwagen-drawer (pp-cart.js). */
(function () {
  function init(root) {
    var main = root.querySelector('[data-fsc-main]');
    var stage = root.querySelector('.fsc-stage');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fsc-thumb]'));
    var vthumb = root.querySelector('[data-fsc-thumb-video]');
    var items = thumbs.slice();
    if (vthumb) items.push(vthumb);

    function tpl(n) {
      var t = root.querySelector('template[data-fsc-tpl="' + n + '"]');
      var v = t && t.content.firstElementChild ? t.content.firstElementChild.cloneNode(true) : null;
      /* Op smalle schermen eerst de 720p-versie (4,5 Mbps) proberen; de 1080p-versie blijft als reserve staan. */
      if (v && window.matchMedia('(max-width: 899px)').matches) {
        var first = v.querySelector('source');
        if (first && /HD-1080p-7\.2Mbps/.test(first.getAttribute('src') || '')) {
          var lean = document.createElement('source');
          lean.setAttribute('src', first.getAttribute('src').replace('HD-1080p-7.2Mbps', 'HD-720p-4.5Mbps'));
          lean.setAttribute('type', 'video/mp4');
          v.insertBefore(lean, first);
        }
      }
      return v;
    }
    function play(v) { if (v && v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    function stopStage() {
      if (!stage) return;
      var old = stage.querySelector('.fsc-vid');
      if (old) { try { old.pause(); } catch (e) {} old.remove(); }
      if (main) main.style.display = '';
    }
    function mark(active) {
      items.forEach(function (o) { o.setAttribute('aria-current', o === active ? 'true' : 'false'); });
      var bar = active.closest('.fsc-thumbs');
      if (bar && bar.scrollWidth > bar.clientWidth) {
        bar.scrollLeft += (active.getBoundingClientRect().left - bar.getBoundingClientRect().left) - (bar.clientWidth - active.offsetWidth) / 2;
      }
    }
    function showImage(t) {
      stopStage();
      mark(t);
      if (!main) return;
      var src = t.getAttribute('data-src');
      /* srcset gaat voor op src: zet dus beide, anders blijft de oude foto staan. */
      main.style.transition = 'opacity .18s ease';
      main.style.opacity = '0';
      var done = function () { main.style.opacity = '1'; };
      main.onload = done;
      main.removeAttribute('srcset');
      main.src = src;
      main.srcset = src.replace(/width=\d+/, 'width=700') + ' 700w, ' + src + ' 1200w';
      main.alt = t.getAttribute('data-alt') || main.alt;
      setTimeout(done, 400);
    }
    function showVideo() {
      var v = tpl('45') || tpl('169');
      if (!v || !stage) return;
      stopStage();
      mark(vthumb);
      if (main) main.style.display = 'none';
      v.classList.add('fsc-vid');
      stage.appendChild(v);
      play(v);
    }
    function current() {
      for (var i = 0; i < items.length; i++) if (items[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }
    function go(i) {
      if (items.length < 2) return;
      i = (i + items.length) % items.length;
      if (items[i] === vthumb) showVideo(); else showImage(items[i]);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t); }); });
    if (vthumb) vthumb.addEventListener('click', showVideo);

    /* Swipe op de foto (mobiel) en pijltjestoetsen op de miniaturen. */
    if (stage && items.length > 1) {
      var sx = 0, sy = 0, tracking = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.target.closest('.fsc-vid') || e.touches.length !== 1) { tracking = false; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(current() + (dx < 0 ? 1 : -1));
      }, { passive: true });
      items.forEach(function (it) {
        it.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { go(current() + 1); items[current()].focus(); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { go(current() - 1); items[current()].focus(); e.preventDefault(); }
        });
      });
    }

    /* Video in het groene vlak: 16:9 op desktop, 4:5 op mobiel (alleen het gekozen bestand wordt geladen). */
    root.querySelectorAll('[data-fsc-own]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wide = window.matchMedia('(min-width: 900px)').matches;
        var v = wide ? (tpl('169') || tpl('45')) : (tpl('45') || tpl('169'));
        if (!v) return;
        var w = document.createElement('div');
        w.className = 'fsc-video fsc-video--own is-playing';
        w.appendChild(v);
        b.replaceWith(w);
        play(v);
      }, { once: true });
    });
    root.querySelectorAll('[data-fsc-video]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-fsc-video') + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.title = b.getAttribute('aria-label') || 'Video';
        b.appendChild(f); b.classList.add('is-playing'); b.removeAttribute('aria-label');
      }, { once: true });
    });

    /* Het thema sluit <details> bij het laden: eerste blok in het groene vlak open houden, de rest naast het product dicht. */
    var firstAcc = root.querySelector('.fsc-brand .fsc-acc');
    if (firstAcc) { [0, 250, 800].forEach(function (ms) { setTimeout(function () { if (!firstAcc.dataset.fscTouched) firstAcc.open = true; }, ms); }); firstAcc.addEventListener('click', function () { firstAcc.dataset.fscTouched = '1'; }); }

    var qty = 1;
    var out = root.querySelector('[data-fsc-qty-out]');
    var totalEl = root.querySelector('[data-fsc-total]');
    var form = root.querySelector('[data-fsc-form]');
    var addon = root.querySelector('[data-fsc-addon]');
    var unit = form ? Number(form.getAttribute('data-fsc-price')) : 0;
    var addonPrice = addon ? Number(addon.getAttribute('data-fsc-addon-price')) : 0;
    function fmt(cents) {
      try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
      catch (e) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }
    }
    function render() {
      if (out) out.textContent = qty;
      if (!totalEl) return;
      var withAddon = addon && addon.checked;
      if (unit > 0 && (qty > 1 || withAddon)) {
        var sum = unit * qty + (withAddon ? addonPrice : 0);
        totalEl.hidden = false;
        totalEl.innerHTML = qty + ' × ' + fmt(unit) + (withAddon ? ' + fles ' + fmt(addonPrice) : '') + ' = <b>' + fmt(sum) + '</b>';
      } else { totalEl.hidden = true; totalEl.textContent = ''; }
    }
    function setQty(n) { qty = Math.max(1, Math.min(99, n)); render(); }
    var minus = root.querySelector('[data-fsc-minus]');
    var plus = root.querySelector('[data-fsc-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });
    if (addon) addon.addEventListener('change', render);

    var msg = root.querySelector('[data-fsc-msg]');
    function add(list, btn) {
      if (!window.fetch) return;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Toevoegen...'; }
      if (msg) msg.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Toevoegen mislukt'); return d; }); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { sourceId: 'pp-fsc', data: {} } }));
          if (btn) { btn.textContent = 'Toegevoegd'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600); }
        })
        .catch(function (e) {
          if (msg) msg.textContent = e.message || 'Toevoegen mislukt, probeer het opnieuw.';
          if (btn) { btn.textContent = label; btn.disabled = false; }
        });
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var list = [{ id: Number(form.querySelector('[name=id]').value), quantity: qty }];
      if (addon && addon.checked) list.push({ id: Number(addon.getAttribute('data-fsc-addon')), quantity: 1 });
      add(list, form.querySelector('[data-fsc-atc]'));
    });
    root.querySelectorAll('[data-fsc-add]').forEach(function (b) {
      b.addEventListener('click', function () { add([{ id: Number(b.getAttribute('data-fsc-add')), quantity: 1 }], b); });
    });

    /* Sticky koopbalk: zichtbaar zolang de hoofdknop niet in beeld is (ook bovenaan de pagina, op mobiel staat die knop ver onder de foto). */
    var sticky = root.querySelector('[data-fsc-sticky]');
    var atc = root.querySelector('[data-fsc-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        sticky.classList.toggle('is-on', !es[es.length - 1].isIntersecting);
      }).observe(atc);
    } else if (sticky) { sticky.classList.add('is-on'); }
  }
  function boot() { document.querySelectorAll('[data-fsc]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();